import React from 'react';
import css from './LogBook.module.scss'
import check from '../../../images/check.svg'
import uncheck from '../../../images/uncheck.svg'
import ReactTooltip from "react-tooltip";
import {filters} from "../../../redux/types";
import {useTheme} from "../../../App";
import {useTranslation} from "react-i18next";

const LogBookItem = ({logItem, selectedFilters, isHover, setHoveredElement, index, isDark, onClick}) => {
  return (
    <div className={`${css.logbook__row} ${isHover && (isDark ? 'bg-darkblue' : 'bg-blue')}`}
         onMouseOver={() => setHoveredElement(index)}
         onClick={onClick}
         onMouseLeave={() => setHoveredElement(null)}>
      {filters.slice(1, filters.length - 1).map((filter, index) => (
        <LogBookCol logItem={logItem} selectedFilters={selectedFilters} filter={filter} key={index} index={index}
                    isDark={isDark}/>
      ))}
    </div>
  );
};

export default React.memo(LogBookItem);

const LogBookCol = ({logItem, selectedFilters, filter, index, isDark}) => {
  const {t} = useTranslation()
  let item = ''
  const {
    role, yacht, miles, tidal, start_marina, operator,
    description, is_draft, night_hours, finish_marina, yacht_type, start_country, finish_country,
    yacht_model
  } = logItem
  const getItem = () => {
    switch (filter.label) {
      case 'role':
        item = role.name;
        break
      case 'yacht':
        item = `${yacht_model?.name} "${yacht?.name}" ${yacht?.year ? `(${yacht.year})` : ''}`;
        break
      case 'miles':
        item = miles !== 0 ? miles : '';
        break
      case 'tidal':
        item = tidal;
        break;
      case 'marinaStart':
        item = `${start_marina?.name ? `${start_marina?.name}, ` : ''} ${start_country?.name ?? ''}`;
        break;
      case 'description':
        item = description ?? '';
        break;
      case 'marinaFinish':
        item = `${finish_marina?.name ? `${finish_marina?.name}, ` : ''} ${finish_country?.name ?? ''}`;
        break;
      case 'yachtType':
        item = yacht_type?.name;
        break;
      case 'route':
        item = `${start_marina?.name ? `${start_marina?.name}, ` : ''} ${start_country?.name} - ${finish_marina?.name ? `${finish_marina?.name}, ` : ''} ${finish_country?.name}`;
        break;
      case 'operator':
        item = operator?.name ?? yacht?.yacht_owner_name ?? '';
        break;
      case 'nh':
        item = night_hours !== 0 ? night_hours : '';
        break;
      default:
        break
    }
  }
  getItem()
  return <div style={{width: filter.width}} className={`${css.logbook__value} 
  ${is_draft && css.logbook__disabledValue} ${!selectedFilters.find(f => f.name === filter.name) && 'hidden-block'}`}>
    {filter.name === 'Приливы' ? <>
      {item !== undefined && <>
        <img data-tip data-for={`${item + index.toString()}`} src={item ? check : uncheck} alt=""/>
        <ReactTooltip style={{color: 'white'}} className={`${isDark && 'tooltip__dark tooltip'}`}
                      backgroundColor={isDark ? '#FFFFFF' : '#52616E'}
                      id={`${item + index.toString()}`} place="top" effect="solid">
          {item === true ? t('tidalRegion') : t('nonTidalRegion')}
        </ReactTooltip>
      </>}

    </> : <>
      <span data-tip
            data-for={`${item + index.toString()}`}>{item?.length > 20 ? `${item.slice(0, 20)}...` : item}</span>
      {(item?.length > 20 || filter.name === 'Мили' || filter.name === 'Н/ч')
      && <ReactTooltip style={{color: 'white'}} className={`${isDark && 'tooltip__dark tooltip'}`}
                       backgroundColor={isDark ? '#FFFFFF' : '#52616E'}
                       id={`${item + index.toString()}`} place="top" effect="solid">
        {filter.name === 'Мили' && t('nauticalMiles')}
        {filter.name === 'Н/ч' && t('nightHours')}
        {(filter.name !== 'Мили' && filter.name !== 'Н/ч') && item}
      </ReactTooltip>}
    </>}
  </div>
}
